var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_26_2",
    "data-name": "Component 26 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.424,
    height: 17.02,
    viewBox: "0 0 17.424 17.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7055",
    "data-name": "Group 7055",
    transform: "translate(10.57 10.661)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    x2: 2,
    y2: 2,
    transform: "translate(0 3)",
    fill: "none",
    stroke: "#4b58ab",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    x1: 5,
    y2: 5,
    transform: "translate(1.5)",
    fill: "none",
    stroke: "#4b58ab",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7056",
    "data-name": "Group 7056",
    transform: "translate(-10.57 -10.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23214",
    "data-name": "Path 23214",
    d: "M12.264,11.74v1.694a5.04,5.04,0,0,0-4.516.615,4.835,4.835,0,0,0-2.1,3.971H4a6.44,6.44,0,0,1,2.562-5.127,6.714,6.714,0,0,1,5.7-1.153Zm-1.653-1.015A4.91,4.91,0,0,1,5.653,5.863a4.96,4.96,0,0,1,9.917,0A4.91,4.91,0,0,1,10.611,10.726Zm0-1.621a3.273,3.273,0,0,0,3.306-3.242,3.306,3.306,0,0,0-6.611,0A3.273,3.273,0,0,0,10.611,9.1Z",
    transform: "translate(-4 -1)",
    fill: "#4b58ab"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verification-icon.981da28cbc957b864d9b4d031392074c.svg";
export { ForwardRef as ReactComponent };